import { render, staticRenderFns } from "./ProductMobile.vue?vue&type=template&id=24b3ba80"
import script from "./ProductMobile.vue?vue&type=script&lang=js"
export * from "./ProductMobile.vue?vue&type=script&lang=js"
import style0 from "./ProductMobile.vue?vue&type=style&index=0&id=24b3ba80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports